// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2rEBO","info":"UpdateTermsInfo_info__3SsNV"};